import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { validImage } from '../../utils/validators';
import  corporation  from '../../assets/images/mine/corporation.png'
import PhoneInput from 'react-phone-number-input';
import { useState } from 'react';
import 'react-phone-number-input/style.css'
import { useEditOrgProfileMutation } from '../../redux/apiSlices/organizationSlice';


function OrganizationGeneralInfo() {
  const { user } = useSelector(state => state.userState)

  const navigate = useNavigate();


  const [editOrgProfile, {isLoading}  ] = useEditOrgProfileMutation();

  const [name, setName] = useState(user.profile.name);
  const [crNumber, setCrNumber] = useState(user.profile.cr_number);
  const [phoneNumber, setPhoneNumber] = useState(user.profile.phone_number);
  const [oldImage, setOldImage] = useState(user.profile.logo);
  const [logo, setLogo] = useState(null);
  const [logoErrorMsg, setLogoErrorMsg] = useState('');


  const nameHandler = (event) => {
    setName(event.target.value);
  }

  const crNumberHandler = (event) => {
      setCrNumber(event.target.value);
    }

  

  const logoHandler = (e) => {
    if (e.target.files[0]) {
      if (validImage(e.target.files[0]?.name)) {
        console.log('valid image')
        let imageUrl = URL.createObjectURL(e.target.files[0]);
        if (logoErrorMsg) {
            setLogoErrorMsg('')
        }
        setLogo({
          image: e.target.files[0],
          imageUrl,
        });
        } else {
          setLogoErrorMsg('not soportet image extention');
          setLogo(null)
        }
      }
    };

  const handleRemoveLogo = () => {
    setLogo(null)
  }

  const phoneNumberHandler = (number) => {
    setPhoneNumber(number);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!logoErrorMsg){
      let formData = new FormData();
      formData.append('name', name);
      formData.append('cr_number', crNumber);
      formData.append('phone_number', phoneNumber);
      if(logo) {
        formData.append('logo', logo.image);
      }
      try {
        await editOrgProfile(formData).unwrap()
        navigate('/organization-dashboard')

      } catch (err) {
          console.error('Failed to save the changes', err)
      }
   }

  };
  return (
    <div class="col-xl-9">
      <div class="card bg-transparent border rounded-3">
          {/* <!-- Card header --> */}
          <div class="card-header bg-transparent border-bottom">
            <h3 class="card-header-title mb-0">تحديث بيانات المؤسسة</h3>
          </div>
          {/* <!-- Card body START --> */}
          <div class="card-body">
          {/* <!-- Form --> */}
            <form class="row g-4">

                {/* <!-- Profile picture --> */}
                <div class="col-12 justify-content-center align-items-center">
                <label class="form-label">صورة شعار المؤسسة</label>
                <div class="d-flex align-items-center">
                    <label class="position-relative me-4" for="uploadfile-1" title="Replace this pic">
                    {/* <!-- Logo place holder --> */}
                    <span class="avatar avatar-xl">
                        <img id="uploadfile-1-preview" class="avatar-img border border-white border-3 shadow" src={logo?.imageUrl ? logo.imageUrl : oldImage ? oldImage :corporation} alt=""/>
                    </span>
                    {/* <!-- Remove btn --> */}
                    <button onClick={handleRemoveLogo} type="button" class="uploadremove"><i class="bi bi-x text-white"></i></button>
                    </label>
                    {/* <!-- Upload button --> */}
                    <label class="btn btn-primary-soft mb-0" for="uploadfile-1">تغيير</label>
                    <input 
                    id="uploadfile-1" 
                    class="form-control d-none" 
                    type="file"
                    onChange={logoHandler}
                    />
                </div>
                </div>

                {/* <!-- Full name --> */}
                <div class="col-lg-6">
                <label class="form-label">اسم المؤسسة</label>
                    <input 
                    type="text" 
                    class="form-control" 
                    value={name} 
                    onChange={nameHandler}
                    placeholder="اسم المؤسسة"
                    />
                    </div>

                <div class="col-lg-6">
                <label class="form-label">رقم السجل التجاري</label>
                    <input 
                    type="number" 
                    class="form-control" 
                    value={crNumber}
                    onChange={crNumberHandler} 
                    placeholder="رقم السجل التجاري"
                    />
                </div>

                {/* <!-- Number --> */}
                <div class="col-lg-6">
                  <label class="form-label">رقم الجوال </label>
                  <div className='dr-ltr'>
                    <PhoneInput
                      defaultCountry="QA"
                      placeholder="رقم الجوال ..."
                      value={phoneNumber}
                      class="form-control"
                      onChange={phoneNumberHandler}
                      />
                      </div>
                </div>

                


                


                {/* <!-- Save button --> */}
                
                <div class="d-flex justify-content-end mt-4">
                    {isLoading ?
                    <button class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        يتم التحميل...
                    </button> 
                    :
                    <button onClick={handleSubmit} class="btn btn-primary mb-0">حفظ التغيير</button>
                    }
                </div>



                

                <div class='row'>
                
                
                </div>


            </form>
          </div>
          {/* <!-- Card body END --> */}
        </div>
	  </div>
  )
}

export default OrganizationGeneralInfo